import { get } from "lodash"
import { createSelector } from "reselect"
import { getModel as getHomeSelectedModel } from "modules/home-layout/selectors/model"

const getModelIdOverride = (_, props) => get(props, "modelId")

export const getModel = createSelector(
  [getHomeSelectedModel, getModelIdOverride],
  (homeSelectedModel, modelIdOverride) => modelIdOverride || homeSelectedModel,
)
